// src/features/editor/components/blocks/BlockEditor.tsx
import type { Block } from '@/types/blocks'
import { InfoBlockEditor } from './InfoBlockEditor'
import { QuizBlockEditor } from './QuizBlockEditor'
import { MatchBlockEditor } from './MatchBlockEditor'
import { ArticleBlockEditor } from './ArticleBlockEditor'
import { VideoBlockEditor } from './VideoBlockEditor'
import { DesignBlockEditor } from './DesignBlockEditor'
import { DisabledBlockPlaceholder } from './DisabledBlockPlaceholder'

interface Props {
  block: Block
  onChange: (next: Block) => void
  onDelete: () => void
  isCourseAuthor: boolean
  // Сохранённый на сервере вариант блока (для гейтинга действий, требующих привязки —
  // например постеры/главы доступны только для уже сохранённого видео).
  savedBlock?: Block | null
  /** Видео-блок: ролик загрузился — сохранить экран сразу (`BlockPanel`). */
  onAutoSave?: () => void
}

export const BlockEditor = ({
  block,
  onChange,
  onDelete,
  isCourseAuthor,
  savedBlock,
  onAutoSave,
}: Props) => {
  if (block.type === 'info') {
    return <InfoBlockEditor block={block} onChange={(n) => onChange(n as Block)} />
  }
  if (block.type === 'quiz') {
    return <QuizBlockEditor block={block} onChange={(n) => onChange(n as Block)} />
  }
  if (block.type === 'match') {
    return <MatchBlockEditor block={block} onChange={(n) => onChange(n as Block)} />
  }
  if (block.type === 'article') {
    return (
      <ArticleBlockEditor
        block={block}
        onChange={(n) => onChange(n as Block)}
        isCourseAuthor={isCourseAuthor}
        onAutoSave={onAutoSave}
      />
    )
  }
  if (block.type === 'video') {
    const saved = savedBlock?.type === 'video' ? savedBlock : null
    return (
      <VideoBlockEditor
        block={block}
        onChange={(n) => onChange(n as Block)}
        isCourseAuthor={isCourseAuthor}
        savedVideoId={saved?.videoId ?? null}
        savedVideoIdEn={saved?.videoIdEn ?? null}
        onAutoSave={onAutoSave}
      />
    )
  }
  if (block.type === 'design') {
    return <DesignBlockEditor block={block} onChange={(n) => onChange(n as Block)} />
  }
  return (
    <DisabledBlockPlaceholder
      typeName={(block as { type: string }).type}
      onDelete={onDelete}
      isCourseAuthor={isCourseAuthor}
    />
  )
}
